import React from 'react';
import './elevecss.css';
import axios2 from '../../../../api/axios';
import  {useState,useEffect} from 'react'
import {Search, 
  PersonPlus, 
  EyeFill, 
  PencilFill, 
  Trash3Fill, 
  PlusCircleFill } from "react-bootstrap-icons"
import { useNavigate, } from 'react-router-dom';
import Swal from 'sweetalert2';
import loadingIcon from '../../../../Images/loading.gif'
import { isEmpty } from '../../../../Utilities/Utils';
import { useAuth } from '../../../../ContextApp/AuthContext';




function Eleve() {
    const [eleves,setEleve]=useState([])
    const [my_classe,setMy_classe]=useState("")
    const [curentpage,setCurentpage]=useState(1)
    const [search,setSearch]=useState('')
    const [recordperpage,setRecordperpage]=useState(50)
    let navigate=useNavigate()
    const [classes,setClasses]=useState([])
    const {user}=useAuth();
    const lastIndex=curentpage * recordperpage
    const firstIndex=lastIndex - recordperpage
    const [loading,setLoading]=useState(false)
    localStorage.setItem("lastpage","/eleve")
    const {logout,typeuser}=useAuth();
    console.log(typeuser)
    useEffect(
        ()=>{
            elevesRequest()
            handle_classe_request()
            
        },[])
    const elevesRequest=async ()=>{
        setLoading(true)
        await axios2.post('api/geteleves',{idecole:user?.ecole?.id,annee_scolaire:user?.programme_scolaire?.annee_scolaire}).then(
            (res)=>{
                setEleve(res.data.items)
                setLoading(false)
               
            }
        ).catch((err)=>{
            
        })
    }
    /*useEffect(()=>{
        const records= search.toLowerCase() === '' ? eleves.slice(firstIndex, lastIndex) : eleves.filter((eleve)=>{return search.toLowerCase() === '' ? eleve : eleve.nom_complet.toLowerCase().includes(search)}).slice(firstIndex, lastIndex)
        const recordNpage=search.toLowerCase() === '' ? eleves : eleves.filter((eleve)=>{ return eleve.nom_complet.toLowerCase().includes(search)})
        const npage=Math.ceil(recordNpage.length/recordperpage)
        const numbers=[...Array(npage+1).keys()].slice(1)   
            function affichage(){
                eleves.length>0 ? 
    
                        records.filter((eleve)=>{
                    return search.toLowerCase() === '' ? eleve : eleve.nom_complet.toLowerCase().includes(search)
                }).map((eleve,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td>{indexV+1}</td>
                            <td>{eleve.nom.toLowerCase() + ' '+ eleve.postnom.toLowerCase() + ' ' + eleve.prenom.toLowerCase()}</td>
                            <td>{eleve.sexe}</td>
                            <td>{eleve.adresse.toLowerCase()}</td>
                            <td>{eleve.date_naissance}</td>
                            <td>{eleve.lieu_naissance.toLowerCase()}</td>
                            <td>{eleve.numero_serni}</td>
                            <td><EyeFill color="lightgreen" size={20} className='d-inline-flex mx-2 icone'  /><PencilFill color="royalblue" size={20} className='d-inline-flex mx-2 icone' onClick={()=>navigate(`${eleve.id}`)}/>  <Trash3Fill color='brown' size={20} className='d-inline-flex mx-2 icone' onClick={()=>AlertNotification(eleve.id)} /> </td>
                        </tr>
                  )
                    
                })
               :
                <div className="">
                    Aucun élève n'a été trouvé
                </div>
            }
    },[eleves])*/
   
    const records= search === '' && my_classe==='' ? eleves.slice(firstIndex, lastIndex) : eleves.filter((eleve)=>{return search === '' && my_classe==='' ? eleve : !isEmpty(my_classe) ? eleve.nom_complet.includes(search) && eleve.idclasse==my_classe : eleve.nom_complet.includes(search)}).slice(firstIndex, lastIndex)
    const recordNpage=search === '' && my_classe==='' ? eleves : eleves.filter((eleve)=>{ return eleve.nom_complet.includes(search) && eleve.idclasse==my_classe})
    const npage=Math.ceil(recordNpage.length/recordperpage)
    const numbers=[...Array(npage+1).keys()].slice(1)    
   //const recordperpage=2
    
    //const numbers=[1,2,3,4,5]
    
    const Iteration=()=>{
        return (loading) ? (
            <div className='w-100 mx-auto'>
                <img src={loadingIcon} alt='loading'/>
            </div>
        ) : (
            records.length > 0 &&
                records.filter((eleve)=>{
                    return search === '' ? eleve : eleve.nom_complet.includes(search)
                }).map((eleve,indexV)=>
                {
                  return(
                        <tr key={indexV} className='ligne'>
                            <td className='sticky-col'>{indexV+1}</td>
                            <td className='sticky-col'>{eleve.nom.toLowerCase() + ' '+ eleve.postnom + ' ' + eleve.prenom}</td>
                            <td>{eleve.sexe}</td>
                            <td>{eleve.adresse.toLowerCase()}</td>
                            <td>{eleve.date_naissance}</td>
                            <td>{eleve.lieu_naissance}</td>
                            <td>{eleve.Numero_serni}</td>
                            <td>{eleve.my_classe}</td>
                            <td className="text-end pe-4">
                                <div className="d-flex justify-content-end gap-2">
                                    {/* Bouton Voir */}
                                    <button 
                                        className="btn btn-sm btn-light text-success border-0 shadow-sm action-btn" 
                                        title="Voir les détails"
                                        onClick={() => navigate(`details/${eleve.id}`)}
                                    >
                                        <EyeFill size={18} />
                                    </button>

                                    {/* Bouton Modifier */}
                                    <button 
                                        className="btn btn-sm btn-light text-primary border-0 shadow-sm action-btn" 
                                        title="Modifier l'élève"
                                        onClick={() => navigate(`${eleve.id}`)}
                                    >
                                        <PencilFill size={16} />
                                    </button>

                                    {/* Bouton Supprimer */}
                                    <button 
                                        className="btn btn-sm btn-light text-danger border-0 shadow-sm action-btn" 
                                        title="Supprimer"
                                        onClick={() => AlertNotification(eleve.id)}
                                    >
                                        <Trash3Fill size={16} />
                                    </button>
                                </div>
                            </td>

                        </tr>
                  )
                    
                }
                )
            
        )
        
            }   
            function AlertNotification(ideleve){
                Swal.fire({
                    title:'Etes-vous sûr de le supprimer ?',
                    text:'Cet élève sera supprimer',
                    icon:'warning',
                    showDenyButton:true,
                    showCancelButton:true,
                    confirmButtonText:'Confirmer',
                    denyButtonText:'Annuler'
                }).then((resultat)=>{
                    if(resultat.isConfirmed){
                        navigate(`/eleve/suppression/${ideleve}`)
                            }
                })
            }
            const handle_classe_request=async()=>{
                try{
                    await axios2.post('api/classes_getter',{idecole:user?.ecole?.id}).then((res)=>{
        
                        setClasses(res.data.items)
                    })
                }
                catch(e){
        
                }
            }
    return(

        <>
       
       <>
    {/* HEADER : Bienvenue */}
    <div className="container-fluid py-4 bg-white border-bottom mb-4">
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div>
                <h2 className="fw-bold text-dark mb-1">
                    Bonjour, <span className="text-primary">{user?.details_eleve?.sexe === "M" ? "M. " : "Mme. "} {user?.details_eleve?.nom}</span> 👋
                </h2>
                <p className="text-muted mb-0">Gestion des inscriptions et suivi des élèves</p>
            </div>
            <div className="bg-primary-subtle p-3 rounded-4 d-flex align-items-center shadow-sm">
                <div className="me-3 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center" style={{width: '45px', height: '45px'}}>
                    <span className="fw-bold">{records.length}</span>
                </div>
                <span className="fw-semibold text-primary">Élèves Inscrits</span>
            </div>
        </div>
    </div>

    {/* FILTRES & ACTIONS */}
    <div className="container-fluid px-4 mb-4">
        <div className="card border-0 shadow-sm p-3">
            <div className="row g-3 align-items-center">
                <div className="col-12 col-md-4">
                    <div className="input-group">
                        <span className="input-group-text bg-light border-0"><Search size={18} /></span>
                        <input 
                            type="text" 
                            className="form-control bg-light border-0" 
                            placeholder="Rechercher un élève..." 
                            value={search} 
                            onChange={(e) => setSearch(e.target.value.toLowerCase())} 
                        />
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-3">
                    <select className="form-select border-0 bg-light" onChange={(e) => setMy_classe(e.target.value)}>
                        <option value="">Toutes les classes</option>
                        {classes.map(cla => <option value={cla.id} key={cla.id}>{cla.nom}</option>)}
                    </select>
                </div>
                <div className="col-12 col-sm-6 col-md-5 d-flex gap-2 justify-content-md-end">
                    <button onClick={() => navigate('insertion')} className="btn btn-success px-4 d-flex align-items-center gap-2 shadow-sm rounded-3">
                        <PersonPlus size={20} />
                        <span>Nouvel Élève</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    {/* DATA : Tableau Responsive */}
    <div className="container-fluid px-4">
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                    <thead className="bg-light">
                        <tr className="text-muted text-uppercase small fw-bold">
                            <th className="ps-4">#</th>
                            <th>Identité</th>
                            <th>Sexe</th>
                            <th>Adresse</th>
                            <th>Date de Naissance</th>
                            <th>Lieu de Naissance</th>
                            <th>Numéro SERNI</th>
                            <th>Classe</th>
                            
                            <th className="text-end pe-4">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Iteration()}
                    </tbody>
                </table>
            </div>
        </div>

        {/* PAGINATION MODERNE */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-3 mb-5">
            <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">Afficher</span>
                <input 
                    type="number" 
                    className="form-control form-control-sm text-center" 
                    style={{width: '70px'}} 
                    value={recordperpage} 
                    onChange={(e) => setRecordperpage(e.target.value)} 
                />
                <span className="text-muted small">par page</span>
            </div>
            
            <nav>
                <ul className="pagination pagination-sm mb-0 shadow-sm">
                    <li className={`page-item ${curentpage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={Prepage}>Précédent</button>
                    </li>
                    {numbers.map(n => (
                        <li key={n} className={`page-item ${curentpage === n ? 'active' : ''}`}>
                            <button className="page-link" onClick={() => changeCPage(n)}>{n}</button>
                        </li>
                    ))}
                    <li className="page-item">
                        <button className="page-link" onClick={Nextpage}>Suivant</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</>

        </>
    )
function Prepage(){
    if(curentpage > 1){
        setCurentpage(curentpage-1)
    }
}
function changeCPage(id){
   setCurentpage(id)
}
function Nextpage(){
    if(curentpage < npage){
       // alert(curentpage)
        setCurentpage(curentpage+1)
    }
}

}
export default Eleve;

